// libraries
import React from 'react'
import clsx from 'clsx'

export interface ButtonRegularProps {
    text: string
    href: string
    target?: boolean
    className?: string
    icon?: {
        svg: string
        position: 'left' | 'right'
    }
    onClick?: (event: React.MouseEvent) => void
}

export default function ButtonRegular({
    text,
    href,
    target,
    className,
    icon,
    onClick
}: ButtonRegularProps) {
    return (
        <a
            href={href}
            target={target ? '_blank' : undefined}
            className={clsx('button-regular', className)}
            onClick={onClick}
        >

            {icon && icon.position === 'left' && (
                <span
                    dangerouslySetInnerHTML={{ __html: icon.svg }}
                    suppressHydrationWarning
                    className='button-regular__icon'
                />
            )}

            <span className='button-regular__text'>
                {text}
            </span>

            {icon && icon.position === 'right' && (
                <span
                    dangerouslySetInnerHTML={{ __html: icon.svg }}
                    suppressHydrationWarning
                    className='button-regular__icon'
                />
            )}

        </a>
    );
}
